<template>
  <div class="filter-rule-column-append" style="position: relative">
    <b-button
      size="sm"
      variant="outline-primary"
      @click="toggleModal"
    >
      {{ filterObject.displayLabel }}
      <Ficon type="chevron-circle-down" />
    </b-button>
    <div
      class="dropdown-menu position-absolute p-2 border-0 shadow-lg"
      style="max-width: 94vw; top: 32px"
      :style="toggle ? 'display: block;' : 'display: none;'"
    >
      <CascadeColumnSelectPanel
        v-if="toggle"
        @column-selected="handleChange"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { inject } from 'vue'
import { FilterControlsService } from '../../../FilterControlsService'
import CascadeColumnSelectPanel from '../CascadeColumnSelectPanel.vue'

export default {
  components: {
    CascadeColumnSelectPanel,
  },
  setup() {
    return {
      filterObject: inject('filterObject'),
      FilterControlsServiceInstance: inject(
        'FilterControlsServiceInstance',
      ) as FilterControlsService,
    }
  },
  data() {
    return {
      toggle: false,
      value: [],
    }
  },
  methods: {
    handleChange(selectedColumnPath: string[] | string) {
      if (typeof selectedColumnPath === 'string') {
        selectedColumnPath = [selectedColumnPath]
      }
      this.selectColumn(selectedColumnPath)
      this.value = []
    },
    selectColumn(selectedColumnPath: string[]) {
      this.filterObject.selectColumn(selectedColumnPath)
      this.closeAppendModal()
    },
    closeAppendModal() {
      this.toggle = false
    },
    toggleModal() {
      this.toggle = !this.toggle
    },
    changeColumnSearchStr(event) {
      this.columnSearchStr = event.target.value
    },
  },
}
</script>
